import React from 'react';
import {Box} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import styles from './property-filter-popup.module.scss'
import {Lx} from '../../../../../../i18n/consts';
import { AutoCompleteItemValue } from '../../../../../../components/shared/nextgen/selector/types';
import Tag from '../../../../../../components/shared/tag';
import TagWrapper from '../../../../../../components/shared/tag-wrapper';

interface Props {
    selectedEmployees: AutoCompleteItemValue[],
    selectedVacationStates: AutoCompleteItemValue[]
}

export default function VacationFilterListPreview(props: Props){
    const intl = useIntl();
    const { selectedEmployees, selectedVacationStates } = props;
    return(<Box display='flex' flexDirection='column' padding={'12px 16px'} gap={'8px'} maxWidth={300} className={styles.filtersView}>
        {
            selectedEmployees.length > 0 && <>
                <div className={styles.filtersTitle}>
                    <FormattedMessage id={Lx.General.EMPLOYEES}/>
                </div>
                <TagWrapper>
                    {selectedEmployees.map((e, key) => (
                        <Tag label={e.name} title={e.name} key={key} showCancelIcon={false}/>))}
                </TagWrapper>
            </>
        }
        {
            selectedVacationStates.length > 0 && <>
                <div className={styles.filtersTitle}>
                    <FormattedMessage id={Lx.Vacation.STATE} />
                </div>
                <TagWrapper>
                    {selectedVacationStates.map((e, key) => {
                        const name = intl.formatMessage({ id: e.name });
                        return (<Tag label={name} title={name} key={key} showCancelIcon={false} />)
                    })}
                </TagWrapper>
            </>
        }
    </Box>)
};
